<template>
  <router-view> </router-view>
</template>

<script>
export default {
  name: 'Layout',
  props: {
  },
  data() {
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
};
</script>
